import createSvgIcon from '../Utils/CreateSvgIcon';

export const Messenger = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12 2C6.75362 2 2.5 5.93775 2.5 10.7962C2.5 13.5655 3.88067 16.0323 6.03796 17.6473V21L9.27429 19.2251C10.1388 19.4626 11.0524 19.5924 12 19.5924C17.2464 19.5924 21.5 15.6539 21.5 10.797C21.5 5.94012 17.2464 2 12 2ZM12.943 13.8483L10.5244 11.2675L5.80371 13.8483L10.9963 8.33594L13.475 10.916L18.1371 8.33594L12.943 13.8483V13.8483Z"
    fillRule="evenodd"
  />,
  'Messenger',
);
